import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from '@app/core/components/error-page/error-page.component';
import { SelectivePreloadingStrategyService } from '@app/core/services/selective-preloading-strategy.service';
import { legacyRoutes } from './legacy-routes';
import { localeRootMatcher, applyLocaleCanMatch } from '../ui/features/i18n';
import { homeRoutes } from '../ui/features/routes/home.routes';
import { localeMyRoute, legacyMyRoute } from '../ui/features/routes/my.routes';
import {
    localeTransactionsRoutes,
    transactionsRoutes,
} from '../ui/features/routes/transactions.routes';
import { wikiRoutes } from '../ui/features/routes/wiki.routes';
import { marketingRoutes } from '../ui/features/routes/marketing.routes';
import { referralUrlCleanupGuard } from './core/guards/referral-url-cleanup.guard';
import { resolvePublicLocaleGuard } from './core/guards/resolve-public-locale.guard';

const localeFeatureRoutes: Routes = [
    localeMyRoute,
    ...localeTransactionsRoutes,
    ...wikiRoutes,
    ...marketingRoutes,
];

const legacyFeatureRoutes: Routes = [
    legacyMyRoute,
    ...transactionsRoutes,
    ...wikiRoutes,
    ...marketingRoutes,
];

const routes: Routes = [
    {
        path: '',
        canActivateChild: [referralUrlCleanupGuard, resolvePublicLocaleGuard],
        children: [
            ...legacyRoutes,
            {
                matcher: localeRootMatcher,
                canMatch: [applyLocaleCanMatch],
                children: [...homeRoutes, ...localeFeatureRoutes],
            },
            ...homeRoutes,
            ...legacyFeatureRoutes,
            {
                path: 'error',
                component: ErrorPageComponent,
            },
            {
                path: '**',
                component: ErrorPageComponent,
            },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            initialNavigation: 'enabledBlocking',
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 42],
            paramsInheritanceStrategy: 'always',
            preloadingStrategy: SelectivePreloadingStrategyService,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
